/** Maximum UTF-16 length of a meeting title (Create Meeting + Meeting Minutes). */
export const MEETING_TITLE_MAX_LENGTH = 255

/** Create Meeting `contextText` → payload `context.text`. */
export const MEETING_CONTEXT_TEXT_MAX_LENGTH = 1000

/** In-meeting Add Context draft → WebSocket `realtime_context`. */
export const REALTIME_CONTEXT_MAX_LENGTH = 1000

/** In-meeting Summary edit draft (`mainContentDraft`). */
export const MAIN_CONTENT_DRAFT_MAX_LENGTH = 1000

/** Quick Feedback popover `comment` → POST `/api/feedback` `{ comment }`. */
export const QUICK_FEEDBACK_COMMENT_MAX_LENGTH = 500

/** Meeting feedback modal `comment` → `feedbackComment`. */
export const MEETING_FEEDBACK_COMMENT_MAX_LENGTH = 1000

/** Meeting Minutes `purpose[]` item. */
export const MINUTES_PURPOSE_ITEM_MAX_LENGTH = 1000

/** Meeting Minutes `topics[].title`. */
export const MINUTES_TOPIC_TITLE_MAX_LENGTH = 500

/** Meeting Minutes `topics[].discussions[]` item. */
export const MINUTES_DISCUSSION_ITEM_MAX_LENGTH = 500

/** Meeting Minutes `topics[].conclusions[]` item. */
export const MINUTES_CONCLUSION_ITEM_MAX_LENGTH = 500

/** Meeting Minutes `action_items[].content`. */
export const MINUTES_ACTION_CONTENT_MAX_LENGTH = 500

/** Meeting Minutes `action_items[].assignee`. */
export const MINUTES_ASSIGNEE_MAX_LENGTH = 255

/** Meeting Minutes `action_items[].deadline`. */
export const MINUTES_DEADLINE_MAX_LENGTH = 255

/**
 * Truncate to a UTF-16 length, matching `String#length` and HTML `maxLength`.
 *
 * @param value Raw input, including paste and programmatic values.
 * @param max Maximum UTF-16 length.
 * @returns `value` when within the limit, otherwise the leading `max` units.
 */
export function clampToMaxLength(value: string, max: number): string {
  return value.length <= max ? value : value.slice(0, max)
}

/**
 * Choose the next draft value without left-slicing existing over-limit text.
 *
 * - `next` within `max` is always accepted.
 * - When `current` is already over `max`, same-length or shorter edits are
 *   kept so a one-character fix does not drop the trailing content.
 * - When `current` is within `max` and `next` exceeds it (paste), clamp.
 */
export function nextLengthLimitedValue(next: string, current: string, max: number): string {
  if (next.length <= max) return next
  if (current.length > max) {
    return next.length <= current.length ? next : current
  }
  return clampToMaxLength(next, max)
}
